import { TruckOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'shipping-providers',
    title: 'Dostavne službe',
    icon: TruckOutlined,
    type: 'item',
    url: '/shipping-providers',
} satisfies NavigationItemType;
